export default __webpack_public_path__ + "static/media/Back Upper Neck.ebb1628c.jpg";